import * as filterEnum from "enums/filterEnum"
import { ContainmentStatus } from "enums/containmentStatus"
import { ContainmentFilterKey } from "enums/filters"

export const Text = filterEnum.Text<ContainmentFilterKey, ContainmentStatus>
export const Date = filterEnum.Date<ContainmentFilterKey, ContainmentStatus>

export const Dropdown = () =>
	filterEnum.Dropdown<ContainmentFilterKey, ContainmentStatus>({
		getter: async ({ api }) => {
			const statuses = await api().ContainmentStatuses()
			return statuses.Members()
		},
		field: "status.name",
		label: "Upload Status",
	})

export const ContainmentSearchFields = [
	Text({
		field: "friendlyId",
		label: "MCC ID",
	}),
	Text({
		field: "name",
		label: "Containment Name",
	}),
	Text({
		field: "createUser.name",
		label: "Created By",
	}),
	Date({
		field: "createDate",
		label: "Created Date",
	}),	
	Dropdown(),
]
